import {RootState} from '../../store';
import {MeteringRecord} from './types';

// FNP-930: the selection slice is typed ISelectionSlice ({[k: string]: unknown})
// because it is shared across modules. RootState is now truly inferred (RTK 2),
// so that `unknown` is visible here instead of being erased by a hand-written
// `Store` annotation. The slice only ever holds whole records for this entity —
// see SelectionSliceFor's addToSelection — so narrowing here is the documented
// "consumers narrow at the use site" contract, not a new assumption.
export const selectionSelector = (state: RootState): Record<string, MeteringRecord> =>
    state['metering-records'].selection as Record<string, MeteringRecord>;
